import Navbar from 'components/navbar';
import { observer } from 'mobx-react-lite';
import { TabPanel, TabView } from 'primereact/tabview';
import React from 'react';
import classes from './calculationScreen.module.scss';
import BootleByRoomTable from './components/BottleByRoomCalculationTable';
import CleanByRoomTable from './components/CleanByRoomTable';
import CleanCalculationScreen from './components/CleanCalculationTable';
import HourlyBPHByRoom from './components/HourlyBPHByRoom';
import HourlyScheduleByRoomTable from './components/HourlyScheduleByRoomTable';
import ProductCalculationScreen from './components/ProductCalculationScreen';
import ScheduleCalculationScreen from './components/ScheduleCalculationTable';
import { useCalculationScreen } from './useCalculationScreen';

const CalculationScreen: React.FC = observer(() => {
  const {
    // State
    activeIndex,
    expandedRows,
    setExpandedRows,
    productData,
    cleanData,
    scheduleData,
    bottleByRoomData,
    cleanByRoomData,
    hourlyBPHByRoomData,
    hourlyScheduleByRoomData,
    loading,
    roomsLoaded,

    // Functions
    handleTabChange,

    // Permissions
    canViewProductCalculations,
    canViewCleanCalculations,
    canViewScheduleCalculations
  } = useCalculationScreen();

  return (
    <div className={classes.calculationScreenContainer}>
      <Navbar heading="Calculations" />
      <div className={classes.content}>
        <div className={classes.headerRow}>
          <h1 className={classes.mainTitle}>Calculations</h1>
        </div>

        <TabView
          activeIndex={activeIndex}
          onTabChange={handleTabChange}
          className={classes.tabView}
        >
          {canViewProductCalculations() && (
            <TabPanel header="Products">
              <ProductCalculationScreen
                roomData={productData}
                loading={loading || !roomsLoaded}
                expandedRows={expandedRows}
                setExpandedRows={setExpandedRows}
              />
            </TabPanel>
          )}

          {canViewCleanCalculations() && (
            <TabPanel header="Clean">
              <CleanCalculationScreen
                roomData={cleanData}
                loading={loading || !roomsLoaded}
                expandedRows={expandedRows}
                setExpandedRows={setExpandedRows}
              />
            </TabPanel>
          )}

          {canViewScheduleCalculations() && (
            <TabPanel header="Schedule">
              <ScheduleCalculationScreen
                roomData={scheduleData}
                loading={loading || !roomsLoaded}
                expandedRows={expandedRows}
                setExpandedRows={setExpandedRows}
              />
            </TabPanel>
          )}

          {canViewCleanCalculations() && (
            <TabPanel header="Clean By Room">
              <CleanByRoomTable
                cleanbyRoomData={cleanByRoomData}
                isLoading={loading || !roomsLoaded}
              />
            </TabPanel>
          )}

          {canViewProductCalculations() && (
            <TabPanel header="Bottle By Shift">
              <BootleByRoomTable roomData={bottleByRoomData} loading={loading || !roomsLoaded} />
            </TabPanel>
          )}

          {canViewProductCalculations() && (
            <TabPanel header="Hourly BPH By Room">
              <HourlyBPHByRoom
                hourlyBPHByRoomData={hourlyBPHByRoomData}
                loading={loading || !roomsLoaded}
              />
            </TabPanel>
          )}

          {canViewScheduleCalculations() && (
            <TabPanel header="Hourly Schedule By Room">
              <HourlyScheduleByRoomTable
                hourlyScheduleByRoomData={hourlyScheduleByRoomData}
                loading={loading || !roomsLoaded}
              />
            </TabPanel>
          )}
        </TabView>
      </div>
    </div>
  );
});

export default CalculationScreen;
